import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center mt-3 mt-md-5 mb-5" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "d-flex justify-content-end mb-3 d-md-none" }
const _hoisted_8 = { class: "bf-account-intro-profile mb-3" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "align-self-start flex-shrink-0 me-4" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "h3 mb-0 d-flex justify-content-between align-items-center" }
const _hoisted_13 = { class: "me-3 text-wrap" }
const _hoisted_14 = { class: "d-none d-md-block" }
const _hoisted_15 = { class: "text-nowrap mt-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-phone" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_18 = { class: "text-nowrap" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "text-nowrap" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-envelope" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_23 = { class: "text-nowrap" }
const _hoisted_24 = { class: "mt-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-paper-plane" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("  Newsletter-Abo: ")
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-edit" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  Profil bearbeiten ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-camera-retro" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Bitte lade ein ")
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" von dir hoch.")
const _hoisted_36 = { class: "mt-5" }
const _hoisted_37 = { class: "d-flex flex-wrap align-items-end mb-4" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, "Deine Kurse")
], -1)
const _hoisted_39 = { class: "ms-auto mt-2 mt-sm-0 mb-md-2 ps-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-tag" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode("  Gutschein einlösen ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-angle-right" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Vergangene Kurse anzeigen")
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3" }, "Vergangene Kurse", -1)
const _hoisted_49 = { class: "mt-5" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-4" }, "Deine Trainingsgebiete", -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "bf-accordion" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "my-0" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "bf-accordion-entry__indicator" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-up" })
], -1)
const _hoisted_56 = { class: "bf-accordion-entry__content" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-2" }, "Jetzt zu Kursen anmelden", -1)
const _hoisted_58 = { class: "d-flex flex-wrap" }
const _hoisted_59 = ["href"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Deine Kurskarten", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Kurskarten kaufen", -1)
const _hoisted_63 = { class: "mt-5" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-5" }, "Weitere Trainingsgebiete", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Du kannst so vielen Trainingsgebieten beitreten, wie du möchtest.")
], -1)
const _hoisted_66 = ["href"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createTextVNode("  Trainingsgebiet suchen ")
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = { key: 1 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Du bist in keinem Trainingsgebiet registriert.")
], -1)
const _hoisted_72 = ["href"]
const _hoisted_73 = { class: "mt-5" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h2", null, "Mein Konto", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-angle-right" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Bestellungen & Rechnungen")
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-angle-right" }, null, -1)
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Konto löschen")
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileAvatarUpload = _resolveComponent("ProfileAvatarUpload")!
  const _component_ProfileEditModal = _resolveComponent("ProfileEditModal")!
  const _component_UnusedTrialCreditAlert = _resolveComponent("UnusedTrialCreditAlert")!
  const _component_UserCourses = _resolveComponent("UserCourses")!
  const _component_UserCoursesArchive = _resolveComponent("UserCoursesArchive")!
  const _component_VoucherRedemptionModal = _resolveComponent("VoucherRedemptionModal")!
  const _component_ProfileRegionCredits = _resolveComponent("ProfileRegionCredits")!
  const _component_RegionProducts = _resolveComponent("RegionProducts")!
  const _component_AppointmentsCalendar = _resolveComponent("AppointmentsCalendar")!
  const _component_UserOrdersModal = _resolveComponent("UserOrdersModal")!
  const _component_ProfileDeleteModal = _resolveComponent("ProfileDeleteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("a", {
                href: "#",
                class: "btn btn-sm btn-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performLogout && _ctx.performLogout(...args)), ["prevent"]))
              }, "Abmelden")
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ProfileAvatarUpload, {
                    avatarUrl: _ctx.profile.avatar_url || (_ctx.assetsBaseUrl + '/img/avatar-missing.jpg'),
                    onUploaded: _cache[1] || (_cache[1] = url => _ctx.profile.avatar_url = url)
                  }, null, 8, ["avatarUrl"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.profile.prename) + " " + _toDisplayString(_ctx.profile.surname), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("a", {
                        href: "#",
                        class: "btn btn-sm btn-primary",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performLogout && _ctx.performLogout(...args)), ["prevent"]))
                      }, "Abmelden")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.profile.phone_mobile || '–'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, [
                      _hoisted_21,
                      _hoisted_22,
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.profile.email || '–'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", null, [
                      _hoisted_25,
                      _hoisted_26,
                      _createElementVNode("i", {
                        class: _normalizeClass(["fa fa-fw", {'fa-check-circle text-success': _ctx.profile.consent_newsletter, 'fa-times-circle text-danger': !_ctx.profile.consent_newsletter}])
                      }, null, 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "btn btn-sm btn-secondary",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openProfileEditModal && _ctx.openProfileEditModal(...args)), ["prevent"]))
                    }, _hoisted_30)
                  ]),
                  (!_ctx.profile.avatar_url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _hoisted_33,
                        _createElementVNode("b", null, [
                          _hoisted_34,
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openAvatarFileSelector && _ctx.openAvatarFileSelector(...args)), ["prevent"]))
                          }, "Profilbild"),
                          _hoisted_35
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_ProfileEditModal, {
                profile: _ctx.profile,
                shown: _ctx.profileEditModalShown,
                onClose: _ctx.closeProfileEditModal,
                onUpdated: _ctx.onProfileUpdated
              }, null, 8, ["profile", "shown", "onClose", "onUpdated"])
            ]),
            _createVNode(_component_UnusedTrialCreditAlert, { class: "mt-5" }),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-primary",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openVoucherRedemptionModal && _ctx.openVoucherRedemptionModal(...args)), ["prevent"]))
                  }, _hoisted_42)
                ])
              ]),
              _createVNode(_component_UserCourses),
              (!_ctx.archiveShown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showArchive && _ctx.showArchive(...args)), ["prevent"]))
                    }, _hoisted_46)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode(_component_UserCoursesArchive)
                  ])),
              _createVNode(_component_VoucherRedemptionModal, {
                shown: _ctx.voucherRedemptionModalShown,
                onClose: _ctx.closeVoucherRedemptionModal,
                onRedeemed: _ctx.onVoucherRedeemed
              }, null, 8, ["shown", "onClose", "onRedeemed"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              (_ctx.profile.regions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.regions, (region) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: region.id,
                          class: _normalizeClass(["bf-accordion-entry", {'bf-accordion-entry--collapsed': region._collapsed}])
                        }, [
                          _createElementVNode("div", {
                            class: "bf-accordion-entry__header",
                            onClick: _withModifiers(($event: any) => (_ctx.toggleRegion(region)), ["prevent"])
                          }, [
                            _createElementVNode("h3", _hoisted_54, _toDisplayString(region.name), 1),
                            _hoisted_55
                          ], 8, _hoisted_53),
                          _createElementVNode("div", _hoisted_56, [
                            _hoisted_57,
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("a", {
                                class: "btn btn-primary mt-2 me-2",
                                href: _ctx.$navigation.buildRouteUrl('region', {slug: region.slug})
                              }, "Gebietsseite öffnen", 8, _hoisted_59),
                              _createElementVNode("a", {
                                class: "btn btn-outline-primary mt-2",
                                href: "#",
                                onClick: _withModifiers(($event: any) => (_ctx.onRegionContactFormClicked(region.id)), ["prevent"])
                              }, "Kontaktformular", 8, _hoisted_60)
                            ]),
                            _hoisted_61,
                            (region._initialized)
                              ? (_openBlock(), _createBlock(_component_ProfileRegionCredits, {
                                  key: 0,
                                  regionId: region.id
                                }, null, 8, ["regionId"]))
                              : _createCommentVNode("", true),
                            _hoisted_62,
                            (region._initialized)
                              ? (_openBlock(), _createBlock(_component_RegionProducts, {
                                  key: 1,
                                  regionId: region.id,
                                  region: region
                                }, null, 8, ["regionId", "region"]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_63, [
                              (_ctx.loaded)
                                ? (_openBlock(), _createBlock(_component_AppointmentsCalendar, {
                                    key: 0,
                                    appointments: _ctx.appointments
                                  }, null, 8, ["appointments"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    _hoisted_64,
                    _hoisted_65,
                    _createElementVNode("a", {
                      class: "btn btn-lg btn-primary",
                      href: _ctx.$navigation.buildRouteUrl('regionSelect')
                    }, _hoisted_69, 8, _hoisted_66)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("a", {
                      class: "btn btn-lg btn-primary",
                      href: _ctx.$navigation.buildRouteUrl('regionSelect')
                    }, "Trainingsgebiet suchen", 8, _hoisted_72)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_73, [
              _hoisted_74,
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openUserOrdersModal && _ctx.openUserOrdersModal(...args)), ["prevent"]))
                }, _hoisted_77)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openProfileDeleteModal && _ctx.openProfileDeleteModal(...args)), ["prevent"]))
                }, _hoisted_80)
              ])
            ]),
            _createVNode(_component_UserOrdersModal, {
              shown: _ctx.userOrdersModalShown,
              onClose: _ctx.closeUserOrdersModal
            }, null, 8, ["shown", "onClose"]),
            _createVNode(_component_ProfileDeleteModal, {
              shown: _ctx.profileDeleteModalShown,
              onClose: _ctx.closeProfileDeleteModal,
              onDeleted: _ctx.onProfileDelete
            }, null, 8, ["shown", "onClose", "onDeleted"])
          ]))
    ])
  ]))
}